import React from "react";
import { Link } from "react-router-dom";
import {
  MODULES,
  MODULES_ACTIONS,
} from "../../../../core/data/constants/moduleConstants";
import HasPermission from "../../../../core/common/wrapper/HasPermission";
import CompanyFilter from "../../../../core/common/crmComponents/CompanyFilter";
import CommonFilter from "../../../../core/common/crmComponents/filters/CommonFilter";
import ClearAllFilters from "../../../../core/common/crmComponents/filters/ClearAllFilters";
import ReloadButton from "../../../../core/common/crmComponents/ReloadButton";

const CardHeader = ({
  toggleLayout,
  layout,
  selectedCompany,
  setSelectedCompany,
}) => {
  const user = JSON.parse(localStorage.getItem("user") || "{}");

  return (
    <div className="card-header py-2">
      <div className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center gap-3">
        {/* Left Section */}
        <div className="d-flex flex-wrap gap-3">
          <ReloadButton moduleName={MODULES.ENROLLMENT} />

          {/* Company Filter */}
          <CompanyFilter
            selectedCompany={selectedCompany}
            setSelectedCompany={setSelectedCompany}
            user={user}
          />
        </div>

        {/* Right Section */}
        <div className="d-flex align-items-center gap-3">
          <div className="gap-1 d-flex align-items-center flex-wrap">
            <CommonFilter module={MODULES.PROFILINGFORM} />
            <ClearAllFilters module={MODULES.PROFILINGFORM} />
          </div>

          {/* Add Lead Button */}
          {/* <HasPermission module={MODULES.LEADS} action={MODULES_ACTIONS.CREATE}>
            <Link
              to="#"
              className="btn btn-primary d-flex align-items-center gap-2 custom-btn-padding"
              data-bs-toggle="offcanvas"
              data-bs-target="#offcanvas_add"
            >
              <i className="ti ti-square-rounded-plus" /> Create Lead
            </Link>
          </HasPermission> */}

          {/* Layout Toggle */}
          {/* <div className="view-icons p-0 d-flex justify-content-center align-items-center">
            <div
              className={`view-icon pb-1 ${layout === "list" ? "active" : ""}`}
              onClick={() => toggleLayout("list")}
            >
              <i className="ti ti-list-tree" />
            </div>
            <div
              className={`view-icon pb-1 ${layout === "grid" ? "active" : ""}`}
              onClick={() => toggleLayout("grid")}
            >
              <i className="ti ti-grid-dots" />
            </div>
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default CardHeader;
